import { Fetch } from "../HttpClient/FetchImplementation/Fetch";
import { AuthenticationMode, createAuthenticationProvider } from "../HttpClient/AuthenticationMode";
import { HttpStatusHandlers, IHttpClient } from "../HttpClient/IHttpClient";
import { ExceptionLogger, HttpClient } from "../HttpClient/HttpClient";

import { INdsPlusApiClient, NdsSverkaParams, NdsSverkaResult } from "./INdsPlusApiClient";

export class NdsPlusApiClient implements INdsPlusApiClient {
    private readonly httpClient: IHttpClient;
    private readonly baseUrl?: string;

    public constructor(
        fetchImpl: Fetch,
        baseUrl?: string,
        resourceZone?: string,
        authentication?: AuthenticationMode,
        exceptionLogger?: ExceptionLogger,
        httpStatusHandlers?: HttpStatusHandlers
    ) {
        this.baseUrl = baseUrl;
        this.httpClient = new HttpClient(
            fetchImpl,
            baseUrl,
            createAuthenticationProvider(authentication),
            {
                resourceZone: resourceZone,
            },
            exceptionLogger,
            httpStatusHandlers
        );
    }

    public getNdsSverkaPageUrl({ inn, kpp, periodYear, formattedPeriodNumber }: NdsSverkaParams) {
        if (!this.baseUrl) {
            throw new Error("Missing baseUrl");
        }

        let url = `${this.baseUrl}app?from=newndspage`;

        url += `#p=y${periodYear}q${formattedPeriodNumber}&inn=${inn}&page=deals&deals_status=3&deals_type=9`;

        if (kpp) {
            url += `&kpp=${kpp}`;
        }

        if (window?.location?.origin) {
            url += `&back=${encodeURIComponent(window.location.origin)}`;
        }

        return url;
    }

    public async getNdsSverkaStatus({
        inn,
        kpp,
        periodYear,
        formattedPeriodNumber,
    }: NdsSverkaParams): Promise<NdsSverkaResult> {
        const url = "api/ke_import";

        const data: { inn: string; period: string; kpp?: string } = {
            inn: inn,
            period: `y${periodYear}q${formattedPeriodNumber}`,
        };

        if (kpp) {
            data.kpp = kpp;
        }

        return await this.httpClient
            .get(url)
            .withQueryParams({ data: JSON.stringify(data) })
            .json<NdsSverkaResult>();
    }
}
